module.exports = __webpack_public_path__ + "static/media/data-cleanliness.dca84f44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceicon2/data-cleanliness.svg
// module id = 419
// module chunks = 0